import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Tabs } from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import styled from "@emotion/styled";
import { Row } from "components/lib";
import { Helper } from "../helper-list/list";
import moment from "moment";
import { useEditHelper } from "utils/helper";

interface TopBarData extends Partial<Helper> {
  creditLimit?: number;
  activeTab?: string;
  tabChange: (key: string) => void;
  refresh: () => void;
}

export const TopBar = (props: TopBarData) => {
  const navigate = useNavigate();
  const {
    uuid,
    nameCn,
    position,
    status,
    createdAt,
    activeTab,
    tabChange,
    refresh,
  } = props;

  const {
    mutate: editHelper,
    isLoading: editLoading,
    isError,
    isSuccess: isEditHelperSuccess,
  } = useEditHelper();

  useEffect(() => {
    if (isEditHelperSuccess) {
      refresh();
    }
  }, [isEditHelperSuccess]);

  const handleDisableHelper = async () => {
    await editHelper({ uuid: uuid, status: status === 1 ? 0 : 1 });
  };

  const onChangeHelperStatus = () => {
    Modal.confirm({
      title: status === 0 ? "deactivate the helper?" : "enable the helper?",
      icon: <ExclamationCircleOutlined />,
      content: status === 0 ? "deactivate this helper?" : "enable this helper?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      maskClosable: true,
      onOk() {
        handleDisableHelper();
      },
    });
  };

  return (
    <>
      <Container>
        <FixedBar between={true}>
          <BarLeft gap={true}>
            <ArrowLeftOutlined onClick={() => navigate(-1)} />
            <Title>{nameCn}</Title>
            <Status> {status === 0 ? "enable" : "disable"}</Status>
            <InfoText>rank: {position}</InfoText>
            <InfoText>
              date of registration: {moment(createdAt).format("YYYY-MM-DD")}
            </InfoText>
          </BarLeft>
          <BarRight>
            <Button onClick={() => onChangeHelperStatus()}>
              {status === 0 ? "disable the helper" : "enable the helper"}
            </Button>
          </BarRight>
        </FixedBar>
        <TabContainer>
          <Tabs activeKey={activeTab} onChange={(key) => tabChange(key)}>
            <Tabs.TabPane tab="work records" key="1"></Tabs.TabPane>
            <Tabs.TabPane tab="payroll records" key="2"></Tabs.TabPane>
            <Tabs.TabPane tab="credit debit" key="3"></Tabs.TabPane>
            <Tabs.TabPane tab="personal information" key="4"></Tabs.TabPane>
            <Tabs.TabPane tab="certificate" key="5"></Tabs.TabPane>
          </Tabs>
        </TabContainer>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  height: 123px;
  padding: 28px 32px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0px;
  z-index: 999;
`;

const FixedBar = styled(Row)`
  z-index: 1;
`;
const BarLeft = styled(Row)``;
const BarRight = styled(Row)``;

const InfoText = styled.div`
  display: inline-block;
  color: #8d939e;
  font-size: 14px;
  padding-right: 10px;
`;

const Title = styled.div`
  color: #3c3e42;
  font-size: 20px;
  font-weight: bold;
`;

const Status = styled.div`
  background-color: #d1f3f8;
  padding: 5px 10px;
  color: #2498aa;
  font-size: 12px;
  font-weight: bold;
  border-radius: 8px;
`;

const TabContainer = styled.div`
  padding-top: 21px;
`;
